import React, {useState} from "react";
import { makeStyles } from "@mui/styles";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import axios from "axios";
import { Dots } from "react-activity";
import "react-activity/dist/library.css";

import { AUTH_ENDPOINT, IMAGES_ENDPOINT, BASE_CUSTOMER_URL } from "../consts";

export const getClientMetadata = async () => {
  let timezone = null;
  let locationPermission = null;

  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch (e) {
    timezone = null;
  }

  try {
    if(navigator.permissions && navigator.permissions.query) {
      const permission = await navigator.permissions.query({ name: 'geolocation' });
      locationPermission = permission.state;
    }
  } catch (e) {
    locationPermission = null;
  }

  return {
    platform: navigator.userAgentData?.platform || navigator.platform || null,
    timezone: timezone,
    language: navigator.language || null,
    screen_width: window.screen?.width || null,
    screen_height: window.screen?.height || null,
    viewport_width: window.innerWidth || null,
    viewport_height: window.innerHeight || null,
    device_pixel_ratio: window.devicePixelRatio || null,
    touch_points: navigator.maxTouchPoints || 0,
    cookies_enabled: navigator.cookieEnabled,
    is_automated: navigator.webdriver === true,
    location_permission: locationPermission,
    color_depth: window.screen?.colorDepth || null,
    hardware_concurrency: navigator.hardwareConcurrency || null,
    device_memory: navigator.deviceMemory || null,
    online: navigator.onLine,
    page_url: window.location.href,
    client_hints: navigator.userAgentData ? {
      brands: navigator.userAgentData.brands || null,
      mobile: navigator.userAgentData.mobile,
      platform: navigator.userAgentData.platform || null,
    } : null,
  };
};

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flex: 1
  },
  signInContainer: {
    display: "flex",
    maxWidth: 400,
    width: "100%",
    height: "100vh",
    backgroundColor: "#ffffff",
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    paddingLeft: 40,
    paddingRight: 40,
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column",
    position: "relative"
  },
  imagesContainer: {
    display: "flex",
    flex: 1,
    backgroundColor: "#00ff00000",
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },
  title: {
    position: "relative",
    width: "100%",
    backgroundColor: "#ffffff"
  },
  signInButton: {
    marginTop: 40,
    width: "100%"
  },
  dots: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center"
  },
  dot: {
    color: "#ffffff",
    fontSize: 18,
    lineHeight: "20px",
    margin: "0 2px",
    animation: "$pulse 1s infinite ease-in-out"
  },
  "@keyframes pulse": {
    "0%, 80%, 100%": { opacity: 0.3 },
    "40%": { opacity: 1 }
  },
  logoContainer: {
    display: "flex",
    marginBottom: 80,
    marginTop: 40,
    justifyContent: "center"
  },
  logo: {
    width: "90%",
    height: "auto"
  },
  logoBottom: {
    width: "33%",
    height: "auto",
    position: "absolute",
    bottom: 20,
    '@media (max-width: 1024px)': {
      display: 'none'
    }
  }
}));

export const SignIn = (props) => {
  const classes = useStyles();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { innerWidth, innerHeight } = window;

  const Dot = ({ delay }) => <span className={classes.dot} style={{ animationDelay: delay }}>•</span>;

  const signIn = async () => {
    setIsLoading(true);

    try {
      const clientMetadata = await getClientMetadata();
      const res = await axios.post(AUTH_ENDPOINT+'?func=authenticate', {
        username: username,
        password: password,
        client_metadata: clientMetadata
      },{
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if(res.status === 200 && res.data && res.data.id_user) {
        const brandColor = res.data.color || res.data.brand_color;
        props.saveCustomerDetails({
          id_customer: res.data.id_customer,
          id_user: res.data.id_user,
          is_admin: res.data.is_admin,
          name: res.data.name,
          username: res.data.username,
          color: brandColor,
          redirect: BASE_CUSTOMER_URL + res.data.redirect + "/?id_customer="+ res.data.id_customer +"&id_user="+ res.data.id_user +"&is_admin="+ res.data.is_admin,
        });
        props.setIsAuthenticated(true);
      } else {
        alert("Sign in failed");
        setIsLoading(false);
      }
    } catch (e) {
      alert("Sign in failed");
      setIsLoading(false);
    }
  }

  return (
    <div className={classes.container}>
      <div className={classes.signInContainer} style={{ backgroundImage: 'url('+IMAGES_ENDPOINT+'background_leftpanel.png)' }}>
        <div className={classes.logoContainer}>
          <img src={IMAGES_ENDPOINT+"logo_circuitos.png"} className={ classes.logo } />
        </div>
        <TextField
          name="username"
          id="username" 
          label="Username" 
          variant="outlined" 
          className={classes.title} 
          onChange={e => {
            setUsername(e.target.value);
          }}
          value={username}
        />
        <TextField
          name="password"
          id="password" 
          label="Password" 
          type="password"
          variant="outlined" 
          className={classes.title} 
          style={{ top: 10 }}
          onChange={e => {
            setPassword(e.target.value);
          }}
          value={password}
        />
        <div className={classes.signInButton}>
          <Button
            style={{width: "100%", backgroundColor: "#141414", color: "#ffffff", fontWeight: "bold", height: 40, display: "flex", alignItems: "center", justifyContent: "center"}}
            onClick={() => { if(!isLoading) signIn(); }}
            disabled={isLoading}
          >
            {isLoading ? (
              <Dots style={{ color: "#ffffff" }} />
            ) : "Sign In"}
          </Button>
        </div>
        <img src={IMAGES_ENDPOINT+"logo.png"} className={ classes.logoBottom } />
      </div>
      <div className={classes.imagesContainer} style={{ backgroundImage: 'url('+IMAGES_ENDPOINT+'background_signin.jpg)' }}>

      </div>
    </div>
  );
  
}
